import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, ControlValueAccessor } from '@angular/forms';
import { chooseOptionsConstant, DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { Document_Upload, Document_Upload_File } from 'src/app/models/common';
import { Subject, of, Observable } from 'rxjs';
import { stateOptionsSample, moduleslist, serviceConstants } from 'src/app/constants/service.constants';
//import * as $ from 'jquery';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { CommonService } from 'src/app/services/common.service';
import { DatePipe } from '@angular/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-document-upload',
  templateUrl: './document-upload.component.html',
  styleUrls: ['./document-upload.component.scss']
})
export class DocumentUploadComponent implements ControlValueAccessor {

  @Input() featureid: string = "";
  @Input() rowid: string = "";
  @Input() ScreenMode: string = "";
  @Input() applicationID: string = "";
  @Input() auditID: string = "";
  documaent_attach_list: Document_Upload[] = [];
  isUploadValid: boolean = true;
  divRow: string = "<div class='row'>";
  divendRow: string = "</div>";
  public validationMessage: string = "";
  FileID: any;
  now = new Date();
  UploadedDate:string;
  isdisabled: boolean = true;
  constructor(private summaryService: GrantsSummaryService, private modalService: NgbModal, public commonService: CommonService,
    public datepipe: DatePipe) { }

  ngOnInit() {
    if (this.rowid == "" || this.rowid == null || this.rowid == undefined)
      this.rowid = "0";
    this.getFeatureDocuments();
    if(this.ScreenMode != 'view')
    {
      this.isdisabled = false;
    }
    else{
      this.isdisabled = true;
    }
  }
  ngOnChanges() {

    if (this.rowid == "" || this.rowid == null || this.rowid == undefined)
      this.rowid = "0";
    if (this.applicationID == "" || this.applicationID == null || this.applicationID == undefined) {
      this.applicationID = "0";
    }
    this.getFeatureDocuments();
  }
  getFeatureDocuments() {
    this.summaryService.getFeatureDocuments(this.featureid, this.rowid, this.applicationID).subscribe(summary => {

      this.documaent_attach_list = summary;
    });
  }

  onModelChange() {
  }

  writeValue(value) {

  }

  registerOnChange(fn) {
  }

  registerOnTouched() { }

  // uploadchange(event, ques: Document_Upload): void {
  //   // debugger
  //   if (ques.UploadFiles == undefined || ques.UploadFiles == null)
  //     ques.UploadFiles = [];
  //     let  Flag=true;
  //     for (let j = 0; j < event.target.files.length; j++) {
  //   var file = event.target.files[j].name;
  //   var ext = file.match(/\.([^\.]+)$/)[1];
  //   var filesize = event.target.files[j].size;
  //   if (file != null && ((filesize > (1024 * 1024 * 10)) || (ext != 'docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf'))) {
  //     this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
  //     Flag=false;
  //     break;
  //   }
  // }
  //   if(Flag)
  //   {
  //     for (let i = 0; i < event.target.files.length; i++) {
  //       let uploadFile = new Document_Upload_File();
  //       uploadFile.ID = this.CreateGuid();
  //       uploadFile.DOCUMENT_NAME = event.target.files[i].name;
  //       uploadFile.File = event.target.files[i];
  //       uploadFile.Status = "Add";
  //       uploadFile.UploadedDate = this.datepipe.transform(this.now.toUTCString(), 'dd-MMM-YYYY');
  //       let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
  //       if (hasValue.length > 0) {
  //         this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
  //         //this.modalService.show(MessageBoxComponent, { data: { heading: '', content: { heading: '', description: 'File already exists with ' + uploadFile.DOCUMENT_NAME + ' Please update the unique file name' } } });
  //       } else {
  //         ques.UploadFiles.push(uploadFile);
  //       }
  //     }
  //   }
  // }

  uploadchange(event, ques: Document_Upload): void {
    let  Flag=true;
    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
       ques.UploadFiles = [];
    for (let i = 0; i < event.target.files.length; i++) {
      let uploadFile = new Document_Upload_File();
      var file = event.target.files[i].name;
      var ext = file.match(/\.([^\.]+)$/)[1];
      var filesize = event.target.files[i].size;

      if (file != null && ((filesize > 15728640) || (ext !='docx' && ext != 'doc' && ext != 'ppt' && ext != 'pptx' && ext != 'xls' && ext != 'xlsx' && ext != 'txt' && ext != 'pdf' )))
      {
        Flag=false;
        //this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
      }
      else
      {
        let uploadFile = new Document_Upload_File();
        uploadFile.ID = this.CreateGuid();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        uploadFile.UploadedDate = this.datepipe.transform(this.now.toUTCString(), 'dd-MMM-YYYY');
        let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase() && x.Status != "Delete");
        if(hasValue.length > 0)
        {
          this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");
        } 
        else if (ques.IsMultipleDocuments) {
          ques.UploadFiles.push(uploadFile);
        } else {
          //ques.UploadFiles = [];
          ques.UploadFiles.forEach((item)=>{
            item.Status="Delete";
          })
          ques.UploadFiles.push(uploadFile);
        }
      }
    }
    if(!Flag)
    this.commonService.ValidationBanner("Please upload files with Word, PPT, Excel, Pdf, Text formats only with maximum size of 15MB");
  }

  DeleteUpload(file, documentattach: Document_Upload): void {
    if (file.Status == "Add") {
      let code = file.ID;
      documentattach.UploadFiles = documentattach.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      file.Status = "Delete";
    }
  }

  public p8(s: boolean): string {
    var p = (Math.random().toString(16) + "000000000").substr(2, 8);
    return s ? "-" + p.substr(0, 4) + "-" + p.substr(4, 4) : p;
  }

  CreateGuid(): string {
    return this.p8(false) + this.p8(true) + this.p8(true) + this.p8(false);
  }

  public validateControls(): string {

    this.isUploadValid = true;
    this.validationMessage = "";
    for (let i = 0; i < this.documaent_attach_list.length; i++) {
      var filelist = this.documaent_attach_list[i].UploadFiles.filter(function (obj) {
        return obj.Status == "Add" || obj.Status == "Edit";
      });
      if (this.documaent_attach_list[i].IsManadatory && this.documaent_attach_list[i].IsDisplay) {
        if (filelist.length == 0) {
          this.isUploadValid = false;
          this.validationMessage += 'Please upload ' + this.documaent_attach_list[i].LabelName + '<br/>'
        }
      }
    }
    return this.validationMessage;
  }

  public saveDocumentUploads(rowid: string,auditID:string,auditRevisionNo:string,): Observable<any> {
    let response: any;
    this.rowid = rowid;
    this.applicationID = rowid;
    this.applicationID = rowid;
    var data = this.documaent_attach_list.filter((item) => {
      return item.IsDisplay == true
    })[0];
    if (data != undefined && data != null) {
    if (this.documaent_attach_list != null && this.documaent_attach_list.length > 0) {
      let formData = new FormData();
      for (let i = 0; i < this.documaent_attach_list.length; i++) {
        this.documaent_attach_list[i].TRANSACTION_ID = rowid;
        if (this.documaent_attach_list[i].UploadFiles != undefined || this.documaent_attach_list[i].UploadFiles != null) {
          for (let j = 0; j < this.documaent_attach_list[i].UploadFiles.length; j++) {
            if (this.documaent_attach_list[i].UploadFiles[j].Status == "Add") {
              formData.append(this.documaent_attach_list[i].UploadFiles[j].ID, this.documaent_attach_list[i].UploadFiles[j].File);

            }
          }
        }
      }
      formData.append("documentattach", JSON.stringify(this.documaent_attach_list));
      formData.append("auditID",auditID);
      formData.append("TRANSACTION_ID",rowid);
      formData.append("auditRevisionNo",auditRevisionNo);
      return this.summaryService.saveFeatureDocuments(formData);
    }
    else {
      let str = '{ "Status": 0 "ErrorCode":"NOCHANGES"}';
      response = JSON.parse(str);
      return of(response);
    }
  } else {
    let str = '{ "Status": 0,"ErrorCode":"NOCHANGES" }';
    response = JSON.parse(str);
      return of(response);
    }
  }

  getUploadDisable(documentattach: Document_Upload): any {
    var filelist = documentattach.UploadFiles.filter(function (obj) {
      return obj.Status == "Add" || obj.Status == "Edit";
    });
    if (!documentattach.IsMultipleDocuments && filelist.length == 0) {
      return true;
    }
    else
      return null;
  }

  OpenFile(item: Document_Upload_File): void {
    if (item.Status == "Edit") {
      let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
      window.open(Url);
    }
  }

  DownloadFile(fileID) {
    //debugger;
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile(fileID, fileName) {
    //debugger;
    this.commonService.previewFile(fileID, fileName, "med");
  }

}
